
/* ============================ PRODUCTION CONFIG BELOW ============================ */

export const config = {  

    // API_URL:    "http://localhost:3000/data",
    // CHAT_URL:   "http://localhost:8000",
    // NOTIF_URL:  "http://localhost:8000",   

    API_URL:   'https://prod-elb-api.teletails.com/data',
    CHAT_URL:  'https://prod-elb-chat.teletails.com',
    NOTIF_URL: 'https://prod-elb-chat.teletails.com',

    VIDEO_BASE_URL: "https://video.teletails.com",
    SELECTED_PARTNER: "dodowell",
    
    payment_amount: 2499,
    subscription_amount_month: 1999,
    subscription_amount_six_months: 9900,
    subscription_amount_six_months_monthly_preview: 1650,

    payment_price_id: "price_1MPXzlF3R1qWAMebyEgyiStX",
    subscription_amount_month_price_id: "price_1KLr6PF3R1qWAMeb2VOwhKm3",
    subscription_amount_six_months_price_id: "price_1L3J7AF3R1qWAMebqp4flfU7",

    partner_id: "61095a8be631947a739a21c7",         
    app_domain: "https://app.dodovet.com",
    PARTNERS: {
       dodo: {
         display_name: "dodowell",
         teletails_name: "dodowell"
       }
    }
}

/* ============================ END PRODUCTION CONFIG    ============================ */


/* ============================ DEVELOPMENT CONFIG BELOW ============================ 

export const config = {  
    
    API_URL:    "http://localhost:3000/data",
    CHAT_URL:   "http://localhost:8000",
    NOTIF_URL:  "http://localhost:8000",   

    // API_URL:    "https://dev-elb-api.teletails.com/data",
    // CHAT_URL:   "https://chat-dev.teletails.com",
    // NOTIF_URL:  "https://chat-dev.teletails.com", 
    
    VIDEO_BASE_URL: "https://beta-video.teletails.com",
    SELECTED_PARTNER: "dodowell",

    payment_amount: 2499,
    subscription_amount_month: 1999,
    subscription_amount_six_months: 9900,
    subscription_amount_six_months_monthly_preview: 1650,

    payment_price_id: "price_1M2X0UF3R1qWAMebrh7YZMw7",
    subscription_amount_month_price_id: "price_1L3L82F3R1qWAMebmsGSKXkB",
    subscription_amount_six_months_price_id: "price_1M2Wy8F3R1qWAMebpBqzgy7D",

    partner_id: "6113b6b59bd2a4783a4bc57f",       
    app_domain: "https://omega.teletails.com",    
    PARTNERS: {
       dodo: {
         display_name: "dodowell",
         teletails_name: "dodowell"
       }
    }
}

/* ============================ END DEVELOPMENT CONFIG    ============================ */

